import { DoorType, DoorUsage } from "app/data/load-board/enums";
import { XGSSelectOption } from "../../../ui-components/xgs-select/xgsSelect";

export interface SecondaryDistributor {
  accountId?: number;
  accountName?: string;
  accountNumber?: number | string;
  accountAttentionName?: string;
  state?: string;
  city?: string;
  address?: string;
  zip?: string;
  country?: string;
}

export interface AssignDoorModalProps {
  show: boolean;
  onClose: () => void;
  onSave?: any;
  onBack?: () => void;
  manifestNumber: number;
  destinationTerminal: number;
  originTerminal?: string;
  shipmentCount?: number;
  initialValues?: Partial<AssignDoorFormValues>;
}

export interface AssignDoorFormValues {
  doorNumber: string;
  priority: string;
  carrier: string;
  trailer: string;
  driverId: string;
  doorUsage: string;
  doorType: string;
  secondaryDistributors: any[];
  secondaryDistributorDetails: SecondaryDistributor[];
}

export interface AddSecondaryDistributorModalProps {
  show: boolean;
  onClose: () => void;
  onAdd: (distributor: SecondaryDistributor) => void;
  existingDistributorIds: string[];
}

export const PRIORITY_OPTIONS: XGSSelectOption[] = [
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
  { label: "4", value: "4" },
  { label: "5", value: "5" },
  { label: "6", value: "6" },
  { label: "7", value: "7" },
  { label: "8", value: "8" },
  { label: "9", value: "9" },
];

export const DOOR_TYPE_OPTIONS: XGSSelectOption[] = [
  { label: "City Delivery", value: DoorType.CITY_DELIVERY },
  { label: "Loading", value: DoorType.LOADING },
  { label: "Overages", value: DoorType.OVERAGES },
  { label: "Rack", value: DoorType.RACK },
  { label: "Staging", value: DoorType.STAGING },
  { label: "Shortages", value: DoorType.SHORTAGES },
  { label: "Unloading", value: DoorType.UNLOADING },
];

export const DOOR_USAGE_OPTIONS: XGSSelectOption[] = [
  { label: "City Rack", value: DoorUsage.CITY_RACK },
  { label: "Local Only", value: DoorUsage.LOCAL_ONLY },
  { label: "Mobile Staging", value: DoorUsage.MOBILE_STG },
  { label: "Non Permanent", value: DoorUsage.NON_PERM },
  { label: "Overage", value: DoorUsage.OVERAGE },
  { label: "Permanent", value: DoorUsage.PERMANENT },
  { label: "WMS", value: DoorUsage.WMS },
  { label: "Shortage", value: DoorUsage.SHORTAGE },
  { label: "Will Calls", value: DoorUsage.WILL_CALLS },
  { label: "Lost", value: DoorUsage.LOST },
];

